var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeviceSync = function SvgDeviceSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 7v1h2V7c0-3.309-2.69-6-6-6h-.999v2h1c2.206 0 4 1.794 4 4ZM7 18.999v-1H5v1c0 3.309 2.69 6 6 6h1v-2h-1c-2.206 0-4-1.794-4-4Z",
    fill: "#7D89FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1H3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm0 12H3V4h7v9ZM23 10h-7a2 2 0 0 0-1.999 2v11a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V12a2 2 0 0 0-2-2Zm0 12h-7v-9h7v9Z",
    fill: "#000",
    stroke: "#fff",
    strokeWidth: 0.3
  })));
};
export default SvgDeviceSync;